<template>
  <div class="space-y-6">
    <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
      <!-- BARRA DE FERRAMENTAS DA TABELA -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-format-list-bulleted-type</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ITENS E PROPOSTAS</h2>
          </div>
          
          <div class="flex items-center gap-4 flex-1 justify-end">
            <div class="flex-none">
              <button 
                @click="$router.push(`/biddings-items/create/${bidding_id}`)"
                class="bg-orange-500 hover:bg-orange-600 text-white shadow-lg flex items-center justify-center gap-2 rounded-lg px-6 py-2 transition-all w-fit max-w-max whitespace-nowrap"
              >
                <v-icon color="white" small>mdi-plus</v-icon>
                <span class="font-bold text-sm uppercase text-white">ADICIONAR ITEM</span>
              </button>
            </div>
            
            <div class="hidden md:flex relative w-64">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <v-icon color="white" small class="opacity-50">mdi-magnify</v-icon>
              </div>
              <input 
                v-model="search"
                placeholder="PESQUISAR ITEM..."
                class="bg-white/10 border border-white/20 rounded-lg py-1.5 pl-10 pr-4 text-[10px] text-white placeholder:text-white/40 focus:outline-none focus:bg-white/20 transition-all w-full uppercase tracking-widest"
              >
            </div>
          </div>
      </div>

      <div class="p-0">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            :loading="loader"
            loading-text="CARREGANDO ITENS..."
            class="custom-table"
            hide-default-footer
          >
            <template v-slot:item.item_price="{ item }">
              <span class="font-medium text-slate-600">{{ realMaskII(item.item_price.toFixed(3)) }}</span>
            </template>
            <template v-slot:item.item_billing_price="{ item }">
              <span class="font-bold text-slate-700">{{ realMaskII(item.item_billing_price.toFixed(3)) }}</span>
            </template>
            <template v-slot:item.item_status="{ item }">
              <v-chip x-small class="font-black tracking-widest" :color="item.item_status ? 'green lighten-5' : 'red lighten-5'" :text-color="item.item_status ? 'green darken-2' : 'red darken-2'">
                {{ item.item_status ? "ATIVO" : "INATIVO" }}
              </v-chip>
            </template>
            <template v-slot:item.item_amount="{ item }">
              <span class="bg-slate-100 text-slate-600 px-2 py-0.5 rounded text-[10px] font-bold">{{ realMask(item.item_amount.toFixed(2)) }}</span>
            </template>
            
            <!-- Ações -->
            <template v-slot:[`item.action`]="{ item }">
              <div class="flex justify-end gap-1">
                <button 
                  @click="$router.push(`/biddings-items/edit/${item.item_id}/${bidding_id}`)"
                  class="p-2 hover:bg-orange-50 text-slate-400 hover:text-orange-500 rounded-lg transition-all"
                  title="Editar"
                >
                  <v-icon small color="currentColor">mdi-pencil-outline</v-icon>
                </button>
                <button 
                  @click="deleteItem(item.item_id)"
                  class="p-2 hover:bg-red-50 text-slate-400 hover:text-red-500 rounded-lg transition-all"
                  title="Excluir"
                >
                  <v-icon small color="currentColor">mdi-trash-can-outline</v-icon>
                </button>
              </div>
            </template>
          </v-data-table>
      </div>
    </section>

    <v-snackbar multi-line border="left" :color="snack.color" v-model="snack.show" transition="scroll-y-reverse-transition">
      <div class="flex items-center gap-3">
        <v-icon color="white">mdi-information-outline</v-icon>
        <span class="font-bold text-xs uppercase tracking-wider text-white">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["bidding_id"],
  mixins: [Helpers],
  data: () => ({
    search: "",
    loader: true,
    data: [],
    snack: {
      show: false,
      message: "",
      color: "",
    },
    headers: [
      { text: "Número", value: "item_number", align: "start", sortable: false },
      { text: "Descrição", value: "item_description_desc" },
      { text: "Participante", value: "provider_name" },
      { text: "Prc Unitário", value: "item_price" },
      { text: "Prc Lic Total", value: "item_billing_price" },
      { text: "Quantidade", value: "item_amount" },
      { text: "Status", value: "item_status" },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/biddings/items/${this.bidding_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    deleteItem(id) {
      if (confirm("Deseja excluir o registro?")) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/biddings/items/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.success || r.data.error;
            this.snack.color = r.data.success ? "success" : "error";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.custom-table ::v-deep table thead th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  height: 48px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.custom-table ::v-deep table tbody td {
  height: 60px !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  font-size: 11px !important;
}

.custom-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}
</style>